import {
  VTextField,
  VAutocomplete,
  VSwitch
} from 'vuetify/components';

import type { FormField } from '@/types/form';

export const CREATE_FORM: FormField[] = [  
  { value: 'name', label: 'Nombre', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'last_name', label: 'Apellido', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'email', label: 'Email', component: VTextField, required: false, col: 12, mdcol:12 },
  //{ value: 'phone', label: 'Teléfono', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'role', 
    label: 'Rol', 
    component: VAutocomplete, 
    searchValue: 'name', 
    required: false, 
    col: 6, 
    mdcol:12, 
    fetchOptions: 'getRoles', 
    itemText: 'name', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      role_id: value?.id,
    }) 
  },
  { value: 'is_active', label: 'Activo', component: VSwitch, col: 6, transform: (v: boolean) => ({ is_active: v ? 1 : 0 }), },
];

const idFieldMappings: Record<string, string> = {
    
};

export const EDIT_FORM: FormField[] = [...CREATE_FORM.map(field => {
  const relatedKey = idFieldMappings[field.value];
  if (relatedKey) {
    return {
      ...field,
      parse: (_: any, item: any) => item[relatedKey] || null,
      transform: (val: any) => ({
        [field.value]: field.multiple
          ? (Array.isArray(val)
              ? val.map(v => v?.[field.itemValue || 'id'] ?? v)
              : [])
          : val?.id ?? val
      })
    };
  }
  if (field.value == 'is_active'){
    return {
      ...field,
      // cuando hidratas el form desde el item del backend:
      parse: (_: any, item: any) => Boolean(Number(item?.is_active)),
      transform: (v: boolean) => ({ is_active: v ? 1 : 0 }),
    }
  }
  return field;
})]

export const HEADERS = [
  { title: 'ID', value: 'id', format: 'text', sortable: true },
  { title: 'Nombre', value: 'name', format: 'text', sortable: true },
  //{ title: 'Teléfono', value: 'attributes.phone', format: 'text', sortable: true },
  { title: 'Rol', value: 'role', format: 'text', sortable: false },
  { title: 'Activo', value: 'is_active', format: 'text', sortable: true },
  
];

export const DEFAULT_HEADER_ORDER = [
  'id',
  'name',
  'role',
  'is_active'
];

export const DETAIL = {
  expand_table: false,
  eye_detail: false,
  key: 'all',
};

export const ROW_ACTIONS = [
  { label: 'Editar', onClick: '__edit', permission:'users.update' },
  { label: 'Eliminar', onClick: '__delete', permission:'users.delete' }
];

export const FILTERS = [
  { value: 'id', label: 'ID', component: VTextField },
  { value: 'name', label: 'Nombre', component: VTextField },
  { value: 'email', label: 'Correo Electrónico', component: VTextField },
  //{ value: 'phone', label: 'Teléfono', component: VTextField },
  
];

export const RENDERERS = {
  'is_active': { name: 'boolean', props: { label: 'Activo' } },
  name: { name: 'combine', props: { paths: ['name', 'last_name'], separator: ' ' } },
};